import { FC } from "react";
import { Route, Routes } from "react-router-dom";
import { AdminWorkTable } from "../tables/adminWork/AdminWorkTable";
import { ReportToolbar } from "../reports/ReportToolbar";
import { useReportFilters } from "../reports/useReportFilters";

// Работы админов: обращения по отделам и сотрудникам за период
export const AdminWorkPage: FC = () => {
  const filters = useReportFilters();

  const tableProps = { dateFrom: filters.dateFrom, dateTo: filters.dateTo };

  return (
    <>
      <div className="px-[5px]">
        <ReportToolbar
          period={filters.period}
          onPeriodChange={filters.selectPeriod}
          onDateFromChange={filters.handleDateFromChange}
          onDateToChange={filters.handleDateToChange}
        />
      </div>
      <div className="px-[5px]">
        <Routes>
          <Route
            path="/accounting"
            element={<AdminWorkTable department="accounting" {...tableProps} />}
          />
          <Route
            path="/tech-support"
            element={
              <AdminWorkTable department="tech-support" {...tableProps} />
            }
          />
          <Route
            path="/selection-support"
            element={
              <AdminWorkTable department="selection-support" {...tableProps} />
            }
          />
          <Route
            path="/disputes"
            element={<AdminWorkTable department="disputes" {...tableProps} />}
          />
          <Route path="/*" element={<AdminWorkTable {...tableProps} />} />
        </Routes>
      </div>
    </>
  );
};
